<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="addForm" ref="addForm" :rules="addFormRules">
				<el-form-item style="margin-top:60px">
					<!--列表-->
					<el-table :data="addForm.goodsList" highlight-current-row v-loading="listLoading" style="width: 100%;">
						<el-table-column type="index" width="50">
						</el-table-column>
						<el-table-column prop="barCode" label="条形码" width="200">
						</el-table-column>
						<el-table-column prop="name" label="名称" width="150" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="brand" label="品牌" width="80">
						</el-table-column>
						<el-table-column prop="form" label="规格" width="250" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="unit" label="单位" width="80">
						</el-table-column>
						<el-table-column prop="price" label="价格" width="100">
						</el-table-column>
						<el-table-column prop="status" label="数量" width="120">
							<template scope="scope">
								<el-input type="number" size="mini" :min="1" :max="99999" value="1" :key="scope.row.id" @change="handleGoodsCountChange(scope.$index, scope.row, $event)" ></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="bidPrice" label="进价" width="120">
							<template scope="scope">
								<el-input type="number" size="mini" :min="1" :max="99999" :value="scope.row.bidPrice" :key="scope.row.id" @change="handleBidPriceChange(scope.$index, scope.row, $event)" ></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="" label="金额" width="100">
							<template scope="scope">
								{{(scope.row.status*(scope.row.bidPrice*1000)/1000).toFixed(4)}}
							</template>
						</el-table-column>
						<el-table-column label="操作" width="120">
							<template scope="scope">
								<el-button size="small" type="danger" icon="el-icon-delete" @click="handleDel(scope.$index, scope.row)"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<br>
				<el-form-item label="总数量">
					<span><b>{{addForm.count}}</b> &nbsp;件</span>
				</el-form-item>
				<el-form-item label="总金额" prop="sum">
					<span><b>{{addForm.sum}}</b> &nbsp;RMB</span>
				</el-form-item>
				<el-button type="warning" @click.native="addSubmit" :disabled="addForm.count<1">入库</el-button>
			</el-form>
		</el-col>

		<el-col class="r">
			<el-form :inline="true" :model="addForm" ref="addForm" :rules="addFormRules">
				<el-form-item>
				  <el-autocomplete
				      class="inline-input select-option"
				      v-model="filters.name"
				      @input="getGoods"
				      @keyup.enter.native="handleEnter"
				      :fetch-suggestions="querySearch"
				      :trigger-on-focus="false"  
				      placeholder="请输入内容"
				      @select="((item)=>handleSelect(item))"
				  >
				  <el-button slot="append" v-on:click="handleGoodsAdd" icon="el-icon-circle-plus"></el-button>
				</el-autocomplete>
				</el-form-item>
				<el-form-item label="供货单位" prop="providerId">
					<el-select v-model="addForm.providerId" filterable placeholder="请选择" clearable>
					    <el-option
					      v-for="item in providers"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item>
					<i v-on:click="handleProviderAdd" class="fa fa-user-plus"></i>
				</el-form-item>
			</el-form>
		</el-col>

		<!--新增供应商界面-->
		<el-dialog title="新增供应商" :visible.sync="addProviderFormVisible" :close-on-click-modal="false">
			<el-form :model="addProviderForm" label-width="80px" :rules="addProviderFormRules" ref="addProviderForm">
				<el-form-item label="公司名" prop="name">
					<el-input v-model="addProviderForm.name"></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contacter">
					<el-input v-model="addProviderForm.contacter"></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="addProviderForm.phone" :maxlength="11"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addProviderFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addProviderSubmit" :loading="addProviderLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增商品界面-->
		<el-dialog title="新增商品" :visible.sync="addGoodsFormVisible" :close-on-click-modal="false">
			<el-form :model="addGoodsForm" label-width="80px" :rules="addGoodsFormRules" ref="addGoodsForm">
				<el-form-item label="条形码" prop="barCode">
					<el-input v-model="addGoodsForm.barCode"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="addGoodsForm.name" @input="getFirstLetter"></el-input>
				</el-form-item>
				<el-form-item label="大写" prop="firstLetter">
					<el-input v-model="addGoodsForm.firstLetter"></el-input>
				</el-form-item>
				<el-form-item label="品牌" prop="brand">
					<el-input v-model="addGoodsForm.brand"></el-input>
				</el-form-item>
				<el-form-item label="规格" prop="form">
					<el-input v-model="addGoodsForm.form"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model="addGoodsForm.unit"></el-input>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input type="number" v-model="addGoodsForm.price" :min="0" :max="99999"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addGoodsFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addGoodsSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getGoodsList, addStock, getDemanderList, addDemander, addGoods} from '../../api/api';
	import '../../common/js/pinyinUtil.js'
	export default {
		data() {
			return {
				filters: {
					name: '',
				},
				goods: [],
				total: 0,
				page: 1,
				pageSize: 20,
				listLoading: false,

				//收银界面数据
				addForm: {
					sum: 0,
					count: 0,
					goodsList: [],
					providerId:''
				},

				addLoading:false,

				//供货商
				providers: [],

				//校验规则
				addFormRules: {
					// providerId: [
					// 	{ required: true, message: '请选择供货单位', trigger: 'blur', type: 'number'}
					// ]
				},

				addProviderFormVisible: false,//新增界面是否显示
				addProviderLoading: false,
				addProviderFormRules: {
					name: [
						{ required: true, message: '请输入供应商', trigger: 'blur' }
					]
				},
				addProviderForm: {
				},

				//商品新增
				addGoodsForm:{
				},
				addGoodsFormVisible:false,
				addGoodsFormRules: {
					name: [
						{ required: true, message: '请输入商品名称', trigger: 'blur' }
					],
					unit: [
						{ required: true, message: '请输入单位', trigger: 'blur' }
					]
				},

			}
		},
		methods: {
			//处理筛选内容
			querySearch(queryString,cb){
				this.ccb = cb;
				let arr = [];
				this.goods.forEach((item,index) => {
					item.value = item.brand+item.form+item.name+'___'+item.price+'元/'+item.unit;
					arr.push(item);
				});
			    cb(arr)
			},
			//处理商品数量
			handleGoodsCountChange: function(index, row, e){
				let oldCount = row.status;
				row.status = Number(e);
				this.addForm.count = util.formatNumber(this.addForm.count + row.status - oldCount);
				this.addForm.sum = util.formatNumber(this.addForm.sum + (row.status - oldCount)*row.bidPrice);
			},
			//处理商品进价
			handleBidPriceChange: function(index, row, e){
				let oldSum = util.formatNumber(row.status*row.bidPrice);
				row.bidPrice = Number(e);
				this.addForm.sum = util.formatNumber(this.addForm.sum + row.status*row.bidPrice -oldSum);
			},
			//处理选择
			handleSelect(item){
				this.filters.name = '';
				this.addForm.goodsList.push(item);
				this.addForm.count+=item.status;
				this.addForm.sum = util.formatNumber(this.addForm.sum + item.status*item.bidPrice);
				this.goods=[];
			},
			//处理回车
			handleEnter(){
				if(this.goods.length>0){
					this.handleSelect(this.goods[0]);
				}
			},
			//删除
			handleDel: function (index, row) {
				this.addForm.goodsList.splice(index,1);
				this.addForm.count-=row.status;
				this.addForm.sum = util.formatNumber(this.addForm.sum - row.status*row.bidPrice);
			},
			//入库
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.addLoading = true;
						addStock(this.addForm).then((res) => {
							this.addLoading = false;
							let msg = res.data.message;
		                	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addForm'].resetFields();
								this.addForm.goodsList=[];
								this.addForm.sum=0;
								this.addForm.count=0;
								this.addForm.providerId='';
							}
						});
					}
				});
			},
			//获取首字母
			getFirstLetter:function(){
				this.addGoodsForm.firstLetter = pinyinUtil.getFirstLetter(this.addGoodsForm.name);
			},
			//显示新增商品界面
			handleGoodsAdd: function () {
				this.addGoodsFormVisible = true;
				this.addGoodsForm = {
					barCode: '',
					name: '',
					firstLetter: '',
					brand: '/',
					form: '',
					unit: '',
					price: 0,
				};
			},
			//新增商品
			addGoodsSubmit: function () {
				this.$refs.addGoodsForm.validate((valid) => {
					if (valid) {
						this.addLoading = true;
						let para = Object.assign({}, this.addGoodsForm);
						addGoods(para).then((res) => {
							this.addLoading = false;
							this.addGoodsFormVisible = false;
							let msg = res.data.message;
            	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								let goods = res.data.data;
								goods.advicePrice='无';	
								goods.status=1;
								this.addForm.goodsList.push(goods);
								this.addForm.count += goods.status;
								this.addForm.sum = util.formatNumber(this.addForm.sum + goods.status*goods.bidPrice);
								this.$refs['addGoodsForm'].resetFields();
							}
						});
					}
				});
			},
			//获取物料倩价列表
			getGoods() {
				let para = {
					page:this.page,
          size:this.pageSize,
          name:this.filters.name
				};
				this.listLoading = true;
				getGoodsList(para).then((res) => {
					this.listLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.goods = res.data.data.list
	                    this.page = res.data.data.pageNum == 0 ? res.data.data.pageNum +1 : res.data.data.pageNum
	                    this.total = res.data.data.total
	                }
				});
			},
			//获取供货单位列表
			getProviders() {
				let para = {
                    role:1
				};
				this.listLoading = true;
				getDemanderList(para).then((res) => {
					this.listLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.providers = res.data.data.list
	                }
				});
			},
			//显示供应商新增界面
			handleProviderAdd: function () {
				this.addProviderFormVisible = true;
				this.addProviderForm = {
					role: 1,
					name: '',
					contacter: '',
					phone: ''
				};
			},
			//新增
			addProviderSubmit: function () {
				this.$refs.addProviderForm.validate((valid) => {
					if (valid) {
						this.addProviderLoading = true;
						let para = Object.assign({}, this.addProviderForm);
						addDemander(para).then((res) => {
							this.addProviderLoading = false;
							this.addProviderFormVisible = false;
							let msg = res.data.message;
            	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addProviderForm'].resetFields();
								this.getProviders();
								this.addForm.providerId=this.providers[0];
							}
						});
					}
				});
			},
		},
		mounted() {
			this.getGoods();
			this.getProviders();
		},
	}

</script>

<style scoped>
	i:hover{ 
		color:#999;
		cursor: pointer;
	}

 .avatar-uploader{
 	width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .signImg {
    width: 50px;
    height: 80px;
  }
  .el-upload {
  	margin-left: 25px;
  }
  img{
  	width:100%;
  	height:100%;
  }
  .el-autocomplete-suggestion{
  		width: 300px;
  	
  }
  .r{
  	position:fixed; 
  	top:120px;
  	padding-left: 20px;
  	padding-top: 5px;
  	padding-bottom: 5px;
  }
  .select-option{
  	width: 600px;
  }

</style>

<style media="print">
    @page {
        size: auto;  /* auto is the initial value */
        margin: 0mm; /* this affects the margin in the printer settings */
    }
</style>

